import { connect } from 'react-redux';
import { toggleCameraControls } from 'actions/InCall/InCallVideo';
import FarEndCameraControls from 'components/FarEndCameraControls/FarEndCameraControls';
import { feccActions } from '@lifesize/nucleus';

const mapActionCreators = (dispatch) => ({
  closeControls: () => dispatch(toggleCameraControls()),
  panLeft: () => dispatch(feccActions.panLeft()),
  panRight: () => dispatch(feccActions.panRight()),
  zoomIn: () => dispatch(feccActions.zoomIn()),
  zoomOut: () => dispatch(feccActions.zoomOut()),
  tiltUp: () => dispatch(feccActions.tiltUp()),
  tiltDown: () => dispatch(feccActions.tiltDown()),
  panLeftStop: () => dispatch(feccActions.panLeftStop()),
  panRightStop: () => dispatch(feccActions.panRightStop()),
  zoomInStop: () => dispatch(feccActions.zoomInStop()),
  zoomOutStop: () => dispatch(feccActions.zoomOutStop()),
  tiltUpStop: () => dispatch(feccActions.tiltUpStop()),
  tiltDownStop: () => dispatch(feccActions.tiltDownStop())
});

export default connect(() => {}, mapActionCreators)(FarEndCameraControls);
